import React from 'react';
import {
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
  Box,
} from '@mui/material';

interface PatientCardRegistrationProps {
  patientCardNumber: string;
  birth: string;
  nickname: string;
  saveCard: boolean;
  onPatientCardNumberChange: (value: string) => void;
  onBirthChange: (value: string) => void;
  onNicknameChange: (value: string) => void;
  onSaveCardChange?: (checked: boolean) => void;
  errors?: {
    patientCardNumber?: string;
    birth?: string;
  };
  touched?: {
    patientCardNumber?: boolean;
    birth?: boolean;
  };
}

const PatientCardRegistration: React.FC<PatientCardRegistrationProps> = ({
  patientCardNumber,
  birth,
  nickname,
  saveCard,
  onPatientCardNumberChange,
  onBirthChange,
  onNicknameChange,
  onSaveCardChange,
  errors = {},
  touched = {},
}) => {
  return (
    <Box component="section" aria-labelledby="patient-card-registration-title">
        <Typography id="patient-card-registration-title" component="h2" variant="h6" sx={{ mb: 1.5 }}>
          診察券情報を入力
        </Typography>
        
        <TextField
          fullWidth
          margin="normal"
          name="patientCardNumber"
          label="診察券番号"
          variant="outlined"
          value={patientCardNumber}
          onChange={(e) => onPatientCardNumberChange(e.target.value)}
          error={touched.patientCardNumber && Boolean(errors.patientCardNumber)}
          helperText={touched.patientCardNumber && errors.patientCardNumber}
        />

        <TextField
          fullWidth
          margin="normal"
          name="birth"
          label="誕生月日"
          placeholder="例：0906"
          type="text"
          value={birth}
          onChange={(e) => onBirthChange(e.target.value)}
          error={touched.birth && Boolean(errors.birth)}
          helperText={touched.birth && errors.birth ? errors.birth : "例：9月6日 → 0906"}
        />

        {onSaveCardChange && (
          <>
            <Box sx={{ mt: 2, bgcolor: "#F2F7FA", px: 2, py: 1, borderRadius: "12px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={saveCard}
                    onChange={(e) => onSaveCardChange?.(e.target.checked)}
                  />
                }
                label="次回もこの診察券を使う"
              />
            </Box>

            {saveCard && (
              <TextField
                fullWidth
                margin="normal"
                name="nickname"
                label="ニックネーム（任意）"
                placeholder="例：太郎の診察券"
                variant="outlined"
                value={nickname}
                onChange={(e) => onNicknameChange(e.target.value)}
              />
            )}
          </>
        )}
    </Box>
  );
};

export default PatientCardRegistration;